module.exports = __webpack_public_path__ + "static/museum-normal-5b684c0f3e1adc686978fe33bf366012.jpg";